module.exports = __webpack_public_path__ + "static/media/splashscreen_image.65a40f96.png";